import React from "react";

const Reports = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "400px",
        padding: "40px",
      }}
    >
      <h1
        style={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "32px",
          fontWeight: "bold",
          color: "#303030",
          marginBottom: "16px",
        }}
      >
        Reports
      </h1>
      <p
        style={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "18px",
          color: "#777",
          textAlign: "center",
        }}
      >
        Coming Soon - This feature will be available in a future update.
      </p>
    </div>
  );
};

export default Reports;

